var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 9,
    viewBox: "0 0 17 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8182 8.6705C15.3676 9.10983 14.6369 9.10983 14.1862 8.6705L8.07802 2.71599L1.96985 8.6705C1.51918 9.10983 0.788483 9.10983 0.337807 8.6705C-0.112871 8.23116 -0.112871 7.51884 0.337807 7.0795L7.262 0.329505C7.71268 -0.109835 8.44337 -0.109835 8.89405 0.329505L15.8182 7.0795C16.2689 7.51884 16.2689 8.23116 15.8182 8.6705Z",
    fill: "#0A1F8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCol);
export default __webpack_public_path__ + "static/media/col.6203b2a3febd613c7016bc0f8602435f.svg";
export { ForwardRef as ReactComponent };